

module.exports = __webpack_require__.stylable.create(
    "Tagline2541018094",
    {"classes":{"root":"Tagline2541018094__root","tagline":"Tagline2541018094__tagline"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Tagline2541018094",
    null
);
